export const ZingGuiSettings = {
  contextMenu: {
    empty: true,
    button: {
      visible: false,
    },
  },
};
